import DiscussionListState from 'flarum/states/DiscussionListState';

export default class PrivateDiscussionLisState extends DiscussionListState { }
